// The Bookings tab of Reports: what became of a branch's confirmed bookings.
// Native review pending (az, ru). Change a phrase in all three languages at once.
// Source words (online, reception), "Source" and the column names reuse
// booking.* and insight.* keys; only the new concepts are here.
import type { Phrase } from '../staffText'

export const bookingsReport = {
  'bookingsReport.tab': { en: 'Bookings', az: 'Bronlar', ru: 'Записи' },
  'bookingsReport.booked': { en: 'Booked', az: 'Bron edilib', ru: 'Записано' },
  'bookingsReport.toCome': { en: '{n} still to come', az: '{n} hələ gözlənilir', ru: 'ещё не наступили: {n}' },
  'bookingsReport.shareOfDue': {
    en: '{share} of {n} due',
    az: 'vaxtı çatmış {n} brondan {share}',
    ru: '{share} из {n} наступившей|{share} из {n} наступивших|{share} из {n} наступивших',
  },
  'bookingsReport.shareOfBooked': { en: '{share} of {n} booked', az: '{n} brondan {share}', ru: '{share} из {n} записи|{share} из {n} записей|{share} из {n} записей' },
  'bookingsReport.movedFrom': { en: 'counted from {date}', az: '{date} tarixindən sayılır', ru: 'считаются с {date}' },
  'bookingsReport.none': { en: 'No bookings in this period', az: 'Bu dövrdə bron yoxdur', ru: 'За этот период записей нет' },
  'bookingsReport.came': { en: 'Came', az: 'Gəlib', ru: 'Пришли' },
  'bookingsReport.onTime': { en: 'On time', az: 'Vaxtında', ru: 'Вовремя' },
  'bookingsReport.arrivalSplit': { en: '{early} early · {onTime} on time · {late} late', az: '{early} tez · {onTime} vaxtında · {late} gec', ru: '{early} раньше · {onTime} вовремя · {late} позже' },
  'bookingsReport.early': { en: 'Early', az: 'Tez', ru: 'Раньше' },
  'bookingsReport.late': { en: 'Late', az: 'Gec', ru: 'Позже' },
  'bookingsReport.against': { en: 'Against the booked time', az: 'Bron vaxtına görə', ru: 'Относительно времени записи' },
  'bookingsReport.againstNote': {
    en: 'On time: {early} min early to {late} min late.',
    az: 'Vaxtında: {early} dəq tez – {late} dəq gec.',
    ru: 'Вовремя: от {early} мин раньше до {late} мин позже.',
  },
  'bookingsReport.typically': { en: 'Typically {value}', az: 'Adətən {value}', ru: 'Обычно {value}' },
  'bookingsReport.earlyBy': { en: '{time} early', az: '{time} tez', ru: 'на {time} раньше' },
  'bookingsReport.lateBy': { en: '{time} late', az: '{time} gec', ru: 'на {time} позже' },
  'bookingsReport.onTheDot': { en: 'on the booked time', az: 'bron vaxtında', ru: 'ко времени записи' },
  'bookingsReport.missed': { en: 'Missed the booking', az: 'Bron vaxtına gəlmədi', ru: 'Не пришли' },
  'bookingsReport.cancelled': { en: 'Cancelled', az: 'Bron ləğv edilib', ru: 'Отменены' },
  'bookingsReport.moved': { en: 'Moved', az: 'Vaxtı dəyişib', ru: 'Перенесены' },
  'bookingsReport.ahead': { en: 'Booked how far ahead', az: 'Nə qədər əvvəl bron edilib', ru: 'За сколько записались' },
  'bookingsReport.lead.sameDay': { en: 'Same day', az: 'Həmin gün', ru: 'В тот же день' },
  'bookingsReport.lead.nextDay': { en: 'Next day', az: 'Növbəti gün', ru: 'На следующий день' },
  'bookingsReport.lead.week': { en: '2–7 days', az: '2–7 gün', ru: '2–7 дней' },
  'bookingsReport.lead.more': { en: '8+ days', az: '8+ gün', ru: '8+ дней' },
  'bookingsReport.waited': { en: 'Waited after booked time', az: 'Bron vaxtından sonra gözləmə', ru: 'Ожидание после времени записи' },
  'bookingsReport.import': { en: 'Import', az: 'Fayldan', ru: 'Из файла' },
} satisfies Record<`bookingsReport.${string}`, Phrase>
